import { useEffect, useState } from "react";
import {
    onAddHoliday,
  onAddWeekend,
  onDeleteWeekend,
  ongetOrgHolidays,
  ongetOrgWeekends,
} from "../services/CalendarConfig";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import { useStateSetter } from "./statehooks/UseStateSettersHook";

export default () => {
  const [holidays, setholidays] = useState<any>([]);
  const [weekends, setweekends] = useState<any>([]);
  const { SelectedOrg, config } = useStateGetter();
  const { setLoading } = useStateSetter();

  const GetOrgHolidays =async  () => {
    setLoading(true);
    try {
      var res = await ongetOrgHolidays(SelectedOrg.id, config);
      setholidays(res.data);
    } catch (e: any) {
      toast.error(e);
    } finally {
      setLoading(false);
    }

  };

  const AddWeekend = async (day: string) => {
    var postdata = {
      days: day,
      organizationID: SelectedOrg.id,
    };

    try {
      var res = await onAddWeekend(postdata, config);
      toast.success("Weekend Added!");
    } catch (e: any) {}
  };
  const AddHoliday = async (data: any) => {
     

    try {
      var res = await onAddHoliday(data, config);

      toast.success("Holiday Added!");
    } catch (e: any) {

        toast.error(e)
    }
  };
  const GetOrgWeekends = async () => {
    setLoading(true);
    try {
      var res = await ongetOrgWeekends(SelectedOrg.id, config);
      setweekends(res.data);
    } catch (e: any) {
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };
  const DeleteWeeekend = async (id: any) => {
    setLoading(true);
    try {
      var res = await onDeleteWeekend(SelectedOrg.id, id, config);
      toast.success("Weekend deleted")
    } catch (e: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetOrgWeekends();
    GetOrgHolidays()
  }, []);
  return { GetOrgHolidays,AddHoliday, DeleteWeeekend,weekends, holidays, AddWeekend, GetOrgWeekends };
};
 